import React from "react";
import "./comparisonTable.css";
import TableEntry from "../BookingTableEntry/TableEntry";
import {
  AlphaLogo,
  KibaSwapLogo,
  MaesteroSwapLogo,
  UniSwapLogo,
} from "../../Assets";
import Fade from "react-reveal/Fade";

const ComparisonTable = () => {
  const allData = [
    {
      id: 1,
      first: "Speed",
      second: "Easy",
      third: "Low on features",
      fourth: "Easy",
      fifth: "Fast",
    },
    {
      id: 2,
      first: "Ease of Use",
      second: "Easy",
      third: "Easy",
      fourth: "Easy",
      fifth: "Diffcult",
    },
    {
      id: 3,
      first: "Features",
      second: "Many usefull features",
      third: "Low on features",
      fourth: "Mid features",
      fifth: "Mid useful features",
    },
    {
      id: 4,
      first: "Multi-Wallet Buying",
      second: "Yes",
      third: "No",
      fourth: "No",
      fifth: "Yes",
    },
    {
      id: 5,
      first: "Cost",
      second: "Transactions charges: 1% Fee on Buys Only",
      third: "Free to use",
      fourth: "Transactions charges: 1% Fee on Buys and 1% Fee of Sells",
      fifth:
        "Transactions charges: 1% Fee on Buys and 1% Fee of Sells and  Monthly subscription of 200 USD.",
    },
    {
      id: 6,
      first: "Overall",
      second:
        "Most user friendly, features packed and low-cost option available in the market. ",
      third: "Free but lacking speed and useful features. ",
      fourth:
        "Compared to the features they provide; their charges are too much.",
      fifth:
        "Has many features but is difficult to use even for some experienced traders. Monthly Subscription fees are a barrier for most people.",
    },
  ];
  return (
    <>
      <Fade top>
        <p className="Alpha_Comparison_Text_Style">
          Comparison of AlphaSwap with others
        </p>
      </Fade>
      <Fade right>
        <div className="Comparison_Content_Conatainer">
          <div className="Swap_Detail_Main_Container">
            <div className="row_Swap_Container">
              {allData.map((item, inddex) => {
                return (
                  <div className="row_swap_Main_Wrapper">
                    <div
                      className="text_Style_start"
                      style={{ textAlign: "left" }}
                    >
                      {item.first}
                    </div>
                    <div className="text_Style">{item.second}</div>
                    <div className="text_Style">{item.third}</div>
                    <div className="text_Style">{item.fourth}</div>
                    <div className="text_Style">{item.fifth}</div>
                  </div>
                );
              })}
            </div>
            <div className="Swap_Detail_Container">
              <div className="Swap_Detail_Logo_Container">
                <img src={AlphaLogo} />
              </div>
              <p className="swap_Text_Style_venders">Alpha Swap</p>
            </div>
            <div className="Swap_Detail_Other_Container">
              <div className="Swap_Detail_Logo_Container">
                <img src={UniSwapLogo} />
              </div>
              <p className="swap_Text_Style_venders">Uni Swap</p>
            </div>
            <div className="Swap_Detail_Other_Container">
              <div className="Swap_Detail_Logo_Container">
                <img src={KibaSwapLogo} />
              </div>
              <p className="swap_Text_Style_venders">Kiba Swap</p>
            </div>
            <div className="Swap_Detail_Other_Container">
              <div className="Swap_Detail_Logo_Container">
                <img src={MaesteroSwapLogo} />
              </div>
              <p className="swap_Text_Style_venders">Maestro</p>
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
};

export default ComparisonTable;
